import { Spinner } from '@cian/ui-kit';
import * as React from 'react';
import { FC } from 'react';

import * as styles from './ElectronicTradingWidgetLoadableFallback.css';

const SPINNER_SIZE = 40;

export const ElectronicTradingWidgetLoadableFallback: FC = () => {
  return (
    <div className={styles['spinner-container']}>
      <Spinner size={SPINNER_SIZE} />
    </div>
  );
};
